export default "__VITE_ASSET__CrohsaLt__"